module.exports = __webpack_public_path__ + "static/media/parita-bianco.82213446.png";